// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ADDRESS = "Adresa";
export const CARD_TEXT = "Popis shopu";
export const EDIT_PROFILE_SETTINGS = "Zme\u0148 \u00fadaje";
export const EMAIL = "Email";
export const HEADING_MY_SHOP = "M\u00f4j obchod";
export const PHONE = "Telef\u00f3n";
export const VENDOR_NAME = "N\u00e1zov V\u00e1\u0161ho shopu";
export const WEB = "Web";
